<template>
  <div v-show="false" />
</template>

<script>
import { mapState, mapActions } from 'vuex'

const RISE_BULK_UPDATE_REPORT_SOURCE = 'rise_bulk_update'

export default {
  name: 'DMRiseBulkNotification',
  computed: {
    ...mapState('user', ['userId'])
  },
  sockets: {
    bulkRiseProgress(data) {
      if (data.requestedBy?._id !== this.userId) {
        return
      }
      this.updateProgress({
        reportId: data.reportId,
        processed: data.processed,
        total: data.total,
        percentage: data.percentage
      })
    },
    reportAvailableForDownloadEvent(data) {
      if (
        data.source !== RISE_BULK_UPDATE_REPORT_SOURCE ||
        data.requestedBy?._id !== this.userId
      ) {
        return
      }
      this.clearProcess({ reportId: data._id })
    }
  },
  methods: {
    ...mapActions('riseBulkProcess', ['updateProgress', 'clearProcess'])
  }
}
</script>
